import React from 'react'

import { useErrorBoundary } from 'react-error-boundary'

import { RenderFirstPageContract } from '@/components/shared/RenderFirstPageContract'
import { AppDependencyUnrecoverableError } from '@/errors/classes/AppDependencyUnrecoverableError'
import { AppOobeContract } from '@/pages/AppOobeValueProp'
import { CloudValuePropContract } from '@/pages/CloudValueProp'
import { PortalValuePropContract } from '@/pages/PortalValueProp'

export function AccountValuePropApp() {
  const { showBoundary } = useErrorBoundary()
  return (
    <RenderFirstPageContract
      contracts={[
        AppOobeContract,
        PortalValuePropContract,
        CloudValuePropContract,
      ]}
      whenNoneMatch={() => showBoundary(new AppDependencyUnrecoverableError())}
    />
  )
}
